import React from 'react';
import { Formik, Field, ErrorMessage } from 'formik';
import Numput from './Numput';
import Selectput from './Selectput';
import Dateput from './Dateput';
import Rangeput from './Rangeput';
import Radioput from './Radioput';
//import { Debug } from './Debug';

import './App.css'


// the locale needs to be regidtered afterwards for our Dateput Component (timezone and date format).
// We then pass it via the Formik date fields. cf. https://www.npmjs.com/package/react-datepicker
import { registerLocale, setDefaultLocale } from "react-datepicker";
import de from 'date-fns/locale/de';
registerLocale('de', de);
setDefaultLocale('de');
const locale = 'de';

const defaultDateFormat = "dd.MM.yyyy";

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms)); 

const required = value => (value ? undefined : 'Required'); 


const destinations = [
  { value: 'afrika-rotes-meer', label: 'Afrika / Rotes Meer' },
  { value: 'asien', label: 'Asien' },
  { value: 'australien-neuseeland', label: 'Australien / Neuseeland' },
  { value: 'indischer-ozean', label: 'Indischer Ozean' },
  { value: 'mittelamerika-karibik', label: 'Mittelamerika / Karibik' },
  { value: 'mittlerer-osten', label: 'Mittlerer Osten' },
  { value: 'nord-mitteleuropa', label: 'Nord- / Mitteleuropa' },
  { value: 'nordamerika', label: 'Nordamerika' },
  { value: 'pazifik-hawaii-suedsee', label: 'Pazifik / Hawaii / Südsee' },
  { value: 'suedamerika', label: 'Südamerika' },
  { value: 'suedeuropa-mittelmeer', label: 'Südeuropa / Mittelmeer' },
]


class Wizard extends React.Component { 
  static Page = ({ children }) => children; 

  constructor(props) {
    super(props);
    let targetPage = this.checkParams(); 
    this.state = {
      page: targetPage,
      values: props.initialValues,
    };
  }
  
  checkParams() {
    let query = window.location.search; 
    switch (query) {
      case '?destination=contact':
        this.props.initialValues.destination = 'contact';
        return 6;
      case '?destination=afrika-rotes-meer':
            this.props.initialValues.destination = 'afrika-rotes-meer';
            return 1;
      case '?destination=asien':
        this.props.initialValues.destination = 'asien';
        return 1;
      case '?destination=australien-neuseeland':
        this.props.initialValues.destination = 'australien-neuseeland';
        return 1;
      case '?destination=indischer-ozean':
        this.props.initialValues.destination = 'indischer-ozean';
        return 1;
      case '?destination=mittelamerika-karibik':
        this.props.initialValues.destination = 'mittelamerika-karibik';
        return 1;
      case '?destination=mittlerer-osten':
        this.props.initialValues.destination = 'mittlerer-osten';
        return 1;
      case '?destination=nord-mitteleuropa':
        this.props.initialValues.destination = 'nord-mitteleuropa';
        return 1;
      case '?destination=nordamerika':
        this.props.initialValues.destination = 'nordamerika';
        return 1;
      case '?destination=pazifik-hawaii-suedsee':
        this.props.initialValues.destination = 'pazifik-hawaii-suedsee';
        return 1;
      case '?destination=suedamerika':
        this.props.initialValues.destination = 'suedamerika';
        return 1;
      case '?destination=suedeuropa-mittelmeer':
        this.props.initialValues.destination = 'suedeuropa-mittelmeer';
        return 1;
      default: return 0;
    }
  }



  next = values =>
    this.setState(state => ({
      page: Math.min(state.page + 1, this.props.children.length - 1),
      values,
    }));

  previous = () =>
    this.setState(state => ({
      page: Math.max(state.page - 1, 0),
    }));

  validate = values => {
    const activePage = React.Children.toArray(this.props.children)[
      this.state.page
    ];
    
    return activePage.props.validate ? activePage.props.validate(values) : {
      
    };
  };


  handleSubmit = (values, bag) => {
    const { children, onSubmit } = this.props;
    const { page } = this.state;
    const isLastPage = page === React.Children.count(children) - 1;
    if (isLastPage) {
      return onSubmit(values, bag);
    } else {
      bag.setTouched({});
      bag.setSubmitting(false);
      this.next(values);
    }
  };


  render() {
    const { children } = this.props;
    const { page, values } = this.state;
    const activePage = React.Children.toArray(children)[page];
    const isLastPage = page === React.Children.count(children) - 1;
    return (
      <Formik
        initialValues={values}
        enableReinitialize={false}
        validate={this.validate}
        validateOnChange={false} 
        validateOnBlur={false}
        onSubmit={this.handleSubmit}
        handleChange={this.handleChange}
        render={({ initialValues, handleSubmit, isSubmitting, handleReset, handleChange }) => (
          <form onSubmit={handleSubmit}>
            {activePage}
            {/*<div className="container btn-container">
              <div className="row">
                <div className="col-sm-12">
                  <div className="button-wrapper">
                    <div className="buttons">
                      {page > 0 && (
                        <button
                          type="button"
                          className="secondary"
                          onClick={this.previous}
                        >
                          « zurück
                </button>
                      )}
                      {!isLastPage && <button type="submit">weiter »</button>}
                      {isLastPage && (
                        <button type="submit" disabled={isSubmitting}>
                          Absenden
                </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>*/}
            {/*<Debug />*/}
          </form> 
        )}
      />
    );
  }
}

 
// function validateLastName(lastName) {
//   const errorMessages = document.querySelector(".formErrorMessages");
//   if (lastName === undefined || lastName.length === 0) {
//     errorMessages.children[0].style.display = "block";
//     document.getElementsByName("lastName")[0].style.borderColor = "#FF0000";
//     return false;
//   }
//   else {
//     document.getElementsByName("lastName")[0].style.borderColor = "#333333";
//     errorMessages.children[0].style.display = "none";
//     return true;
//     }
// }

// function validateEmail(email) { 
//   const errorMessages = document.querySelector(".formErrorMessages");

//   if (/[^@\s]+@[^@\s]+\.[^@\s]+/.test(email) == false) {
//     document.getElementsByName("email")[0].style.borderColor = "#FF0000";
//     errorMessages.children[0].style.display = "block";
//     return false;
//   }
//   else {
//     document.getElementsByName("email")[0].style.borderColor = "#333333";
//     errorMessages.children[0].style.display = "none";
//     return true;
//   }
// }

function validateRequiredFields(lastName, email) {
  if(lastName === undefined || lastName.length === 0 || /[^@\s]+@[^@\s]+\.[^@\s]+/.test(email) == false) {
    document.getElementsByClassName("formErrorMessages")[0].children[0].style.display = "block";
    if(lastName === undefined || lastName.length === 0) {
      document.getElementsByName("lastName")[0].style.borderColor = "#FF0000";
    }
    else {
      document.getElementsByName("lastName")[0].style.borderColor = "#333333";
    }
    if(/[^@\s]+@[^@\s]+\.[^@\s]+/.test(email) == false) {
      document.getElementsByName("email")[0].style.borderColor = "#FF0000";
    }
    else {
      document.getElementsByName("email")[0].style.borderColor = "#333333";
    }
    return false;
  }
  else {
    document.getElementsByName("lastName")[0].style.borderColor = "#333333";
    document.getElementsByName("email")[0].style.borderColor = "#333333";
    document.getElementsByClassName("formErrorMessages")[0].children[0].style.display = "none";
    return true;
  }
}



const App = () => (
  <div className={"booking-form"}>
    <h1>Exklusives-Reisen.ch: Reise Buchen </h1>
    <Wizard
      id="wiz"
      initialValues={{ 
      }}
      
      onSubmit={(values, actions) => {
        sleep(300).then(() => {
            if(validateRequiredFields(values.lastName, values.email)) {
              var http = new XMLHttpRequest();
              let url = '/form-handler.php';
              let params = JSON.stringify(values, null, 2);
              http.open('POST', url, true);
              //Send the proper header information along with the request
              http.setRequestHeader('Content-type', 'application/json');

              http.onreadystatechange = function () {//Call a function when the state changes.
                if (http.readyState == 4 && http.status == 200) {
                  window.location.pathname = '/vielen-dank';
                }
              }
              http.send(params);
            }
            else {
              document.querySelector(".buttons>button[type='submit']").disabled = false;
            }
        });
      }}
    >
      <Wizard.Page>
        <div className="wizard-wrapper wrapper-1">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="progress">
                  <span className="step active" ></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                </div>
                <div className="wizard-page page-1">
                  <h2 className="wizard-page-title">Welches Ziel möchten Sie bereisen?</h2>

                  <Field
                    name="destination"
                    component={Selectput}
                    type="text"
                    placeholder="Ziel wählen"
                    options={destinations}
                    multi="false"
                    validate={required} 
                  />
                  <ErrorMessage
                    name="lastName"
                    component="div"
                    className="field-error"
                  />
                </div>


                <div className="buttons">
                  <button type="submit">weiter</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </Wizard.Page>

      <Wizard.Page>
        <div className="wizard-wrapper wrapper-2">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="progress">
                  <span className="step" ></span>
                  <span className="step active"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                </div>
              </div>
              
              <div className="col-md-12 col-lg-10 offset-lg-1"> 
                <div className="wizard-page page-2">
                  <h2 className="wizard-page-title">Wie viele Personen wollen reisen?</h2>
                  <Field
                    name="adultCount"
                    component={Numput}
                    type="number"
                    value="1"
                    labelclassName="icon-adult"
                    label="Erwachsene"
                  />
                  <Field
                    name="childCount"
                    component={Numput}
                    type="number"
                    value="0"
                    labelclassName="icon-child"
                    label="Kinder"
                  />
                  <Field
                    name="babyCount"
                    component={Numput}
                    type="number"
                    value="0"
                    labelclassName="icon-baby"
                    label={'Kleinkinder\n (< 6 Mon.)'}
                  />
                  <div className="buttons col-sm-12">
                    <button type="submit">weiter</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </Wizard.Page>
      <Wizard.Page>
        <div className="wizard-wrapper wrapper-3">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="progress">
                  <span className="step" ></span>
                  <span className="step"></span>
                  <span className="step active"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                </div>
              </div>
              
              <div className="col-md-12 col-lg-10 offset-lg-1">
                <div className="wizard-page page-3">
                  <h2 className="wizard-page-title">In welchem Zeitraum möchten Sie reisen?</h2>
                  <div className="date-tolerance-group">
                    <label>Anreise</label>
                    <Field
                      name="startDate"
                      component={Dateput}
                      type="date"
                      locale={locale}
                      validate={required}
                      //value={new Date()}
                      dateFormat={defaultDateFormat}
                    />
                    <ErrorMessage
                      name="lastName"
                      component="div"
                      className="field-error"
                    />
                    <Field
                      name="startTolerance"
                      component={Numput}
                      type="number"
                      value="1"
                      labelclassName="tolerance"
                      label="Toleranz"
                    />
                  </div>
                  <div className="date-tolerance-group">
                    <label>Rückreise</label>
                    <Field
                      name="endDate"
                      component={Dateput}
                      type="date"
                      locale={locale}
                      //value={new Date()}
                      validate={required}
                      dateFormat={defaultDateFormat}
                    />
                    <ErrorMessage
                      name="lastName"
                      component="div"
                      className="field-error"
                    />
                    <Field
                      name="endTolerance"
                      component={Numput}
                      type="number"
                      value="1"
                      labelclassName="tolerance"
                      label="Toleranz"

                    />
                  </div>
                  <div className="buttons">
                    <button type="submit">weiter</button>
                  </div>
                  {/*Formik />*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Wizard.Page>
      <Wizard.Page>
        <div className="wizard-wrapper wrapper-4">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="progress">
                  <span className="step" ></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step active"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                </div>
              </div>

              <div className="col-md-12 col-lg-10 offset-lg-1"> 
                <div className="wizard-page page-4">
                  <h2 className="wizard-page-title">Wie möchten Sie fliegen?</h2>
                  <div className="flight-class-group">
                    <Field type="radio" component={Radioput} name="flightClass" value="economy" iconClass1="icon-plane icon-plane-economy" labelText="Economy Class" />
                    <Field type="radio" component={Radioput} name="flightClass" value="business" iconClass1="icon-plane icon-plane-business" labelText="Business Class" />
                    <Field type="radio" component={Radioput} name="flightClass" value="first" iconClass1="icon-plane icon-plane-first" labelText="First Class" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Wizard.Page>

      <Wizard.Page>
        <div className="wizard-wrapper wrapper-5">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-lg-10 offset-lg-1"> 
                <div className="progress">
                  <span className="step" ></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step active"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                </div>
                <div className="wizard-page page-5">
                  <h2 className="wizard-page-title">Welches Budget möchten Sie festlegen?</h2>
                  <div className="budget-group">
                    <Field
                      name="budget"
                      component={Rangeput}
                      minLabel="min."
                      maxLabel="max."
                      minBorder="850"
                      maxBorder="50000"
                      values={[1000, 5000]}
                    />
                    <ErrorMessage
                      name="budget"
                      component="div"
                      className="field-error"
                    />
                  </div>
                  <div className="buttons">
                    <button type="submit">weiter</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Wizard.Page>

      <Wizard.Page>
        <div className="wizard-wrapper wrapper-6">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="progress">
                  <span className="step" ></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step active"></span>
                  <span className="step"></span>
                </div>
                <div className="wizard-page page-6">
                  <h2 className="wizard-page-title">Welche Verpflegung möchten Sie genießen?</h2>
                  <div className="service-group">
                    <Field type="radio" component={Radioput} name="service" value="bed" iconClass1="icon-bed" labelText="Übernachtung" />
                    <Field type="radio" component={Radioput} name="service" value="bed-breakfast" iconClass1="icon-bed-breakfast" labelText="Übernachtung + Frühstück" />
                    <Field type="radio" component={Radioput} name="service" value="halfboard" iconClass1="icon-halfboard" labelText="Halbpension" />
                    <Field type="radio" component={Radioput} name="service" value="all-inclusive" iconClass1="icon-all-inclusive" labelText="All inclusive" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Wizard.Page>

      <Wizard.Page>
        <div className="wizard-wrapper wrapper-7">
          <div className="container">
            <div className="row"> 
              {/* hide progress bar on last screen */}
              <div className="col-sm-12">
                <div className="progress">
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step"></span>
                  <span className="step active"></span>
                </div>
                </div>
                <div className="col-md-12 col-lg-10 offset-lg-1">
                  <div className="wizard-page page-7">
                    <div className="row">{/* submit-main-flexbox */}
                      <div className="col-sm-12 col-md-6 submit-left-flexbox">{/* submit-left-flexbox */}
                        <p>Und das Abenteuer kann beginnen.</p>
                        <br></br><br></br>
                        <p>Wohin dürfen<br /> wir unsere<br /> Reisevorschläge senden?</p>
                      </div>
                      <div className="col-sm-12 col-md-6 submit-right-flexbox">{/* submit-right-flexbox */}
                        <div className="formErrorMessages">
                          <p>
                            Bitte füllen Sie die Felder mit * aus.
                          </p>
                        </div>
                        <div>
                          <label className={"radio-button"}>
                            <Field type="radio" name="salutation" value="Frau" checked="checked" />
                            Frau
                          </label>
                          <label className={"radio-button"}>
                            <Field type="radio" name="salutation" value="Herr" />
                            Herr
                          </label>
                        </div>
                        <div>
                          <label>First Name</label>
                          <Field
                            name="firstName"
                            component="input"
                            type="text"
                            placeholder="Vorname"
                          />
                          <ErrorMessage
                            name="firstName"
                            component="div"
                            className="field-error"
                          />
                        </div>
                        <div>
                          <label>Last Name</label>
                          <Field
                            name="lastName"
                            component="input"
                            type="text"
                            placeholder="Nachname *"
                          />
                          <ErrorMessage
                            name="lastName"
                            component="div"
                            className="field-error"
                          />
                        </div>
                        <div>
                          <label>E-Mail Adresse</label>
                          <Field
                            name="email"
                            component="input"
                            type="email"
                            placeholder="E-Mail Adresse *" 
                          />
                          <ErrorMessage name="email" component="div" className="field-error" />
                        </div>

                        <div>
                          <label>Telefon</label>
                          <Field
                            name="phone"
                            component="input"
                            type="phone"
                            placeholder="Telefon"
                          />
                          <ErrorMessage name="phone" component="div" className="field-error" />
                        </div>
                        <div>
                          <label>Nachricht</label>
                          <Field
                            name="message"
                            component="textarea"
                            rows="5"
                            placeholder="Nachricht"
                          />
                          <ErrorMessage name="message" component="div" className="field-error" />
                        </div>
                        <div className="buttons">
                          <button type="submit">absenden</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </Wizard.Page> 
    </Wizard>
  </div>
);


export default App;